import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendGetRequest } from '../../../api/requestUtil';

export const getPublicProfile = createAsyncThunk(
  'get-public-profile',
  async (username: string, { getState }) => {
    const token = (getState() as AppState).user.authToken || null;
    return sendGetRequest(`/api/public-profile/${username}/`, token);
  }
);

export const getPublicUserActivities = createAsyncThunk(
  'get-public-user-activities',
  async (username: string) => {
    return sendGetRequest(`/api/public-profile/${username}/activities/`);
  }
);